import { createModelSegment } from 'client/data/luckdragon/segment';

export const PageModel = createModelSegment('pageContext', []);
